(function () {
  var map = window.BB_TOONS || {};
  function bind(el, handle) {
    var row = map[handle];
    if (!el || !row || !row.toon) return;
    var old = el.querySelector(".bb-toon-layer");
    if (old) old.remove();
    el.classList.add("bb-swap");
    var img = document.createElement("img");
    img.className = "bb-toon-layer";
    img.src = row.toon;
    img.alt = "";
    el.appendChild(img);
    if (el.getAttribute("data-bb-bound") === "1") return;
    el.setAttribute("data-bb-bound", "1");
    el.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse") return;
      el.classList.add("is-open");
    });
    el.addEventListener("pointerup", function () { el.classList.remove("is-open"); });
    el.addEventListener("pointerleave", function () { el.classList.remove("is-open"); });
    el.addEventListener("pointercancel", function () { el.classList.remove("is-open"); });
  }
  function scan() {
    document.querySelectorAll("[data-bb-handle]").forEach(function (el) {
      bind(el, el.getAttribute("data-bb-handle"));
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  window.bbToonBind = bind;
})();
